export class DBCSString {
  static isDBCS(char: string) {
    const charCode = char.charCodeAt(0);
    if (charCode < 128) {
      return false;
    } else {
      return true;
    }
  }

  static containsDBCS(str: string) {
    for (let i = 0; i < str.length; i++) {
      if (this.isDBCS(str.charAt(i))) {
        return true;
      }
    }
    return false;
  }

  static encodeUtf8(str: string) {
    return unescape(encodeURIComponent(str));
  }

  static getLengthInBytes(str: string) {
    let length = 0;
    for (let i = 0; i < str.length; i++) {
      const ch = str.charCodeAt(i);
      length = length + (ch < 128 ? 1 : this.encodeUtf8(str[i]).length);
    }
    return length;
  }

  static substrUtf8Bytes(
    str: string,
    startInBytes: number,
    lengthInBytes: number
  ) {
    let resultStr = '';
    let startInChars = 0;
    const strBytesLength = this.getLengthInBytes(str);
    if (startInBytes < 0) {
      startInBytes = startInBytes + strBytesLength;
    }
    for (let bytePos = 0; bytePos < startInBytes; startInChars++) {
      const ch = str.charCodeAt(startInChars);
      bytePos += ch < 128 ? 1 : this.encodeUtf8(str[startInChars]).length;
    }

    if (startInBytes + lengthInBytes > strBytesLength) {
      lengthInBytes = strBytesLength - startInBytes;
    }

    let end = startInChars + lengthInBytes - 1;
    for (let n = startInChars; startInChars <= end; n++) {
      const ch = str.charCodeAt(n);
      end -= ch < 128 ? 1 : this.encodeUtf8(str[n]).length;
      if (str[n]) resultStr += str[n];
    }

    return resultStr;
  }
}
